// =============================================================================
// cadenasAdmin.js : le cadenas ouvert des pages réservées aux administrateurs
// (demande de Pierre du 14/10/2026 : « met à côté du nom de la page un petit
// cadenas ouvert comme ça je n'hésite plus »).
// -----------------------------------------------------------------------------
// Ouvert, parce que la page est ouverte à celui qui la voit : il signale une
// page que les membres ne voient pas, il n'interdit rien. Posé à côté du nom
// de la page : fil « Enio / module / page » et titre au doigt (Header.js),
// sommaire et lignes du rail (RailNavigation.js), lignes des pages d'accueil
// des modules (HubLigne). Qui est réservé se CALCULE dans buildNavModules
// (`reserveAdmin`), jamais ici. Le tracé vient du jeu étendu, chargé à la
// demande (IconeTexte) : le bundle principal n'en porte rien.
// =============================================================================
import { IconeTexte } from "./icones";

export const TITRE_CADENAS = "Réservée aux administrateurs";

// Une géométrie en em passe par --em-ajuste (WebKit y applique l'échelle deux fois).
const STYLE = { marginInlineStart: "calc(0.3em * var(--em-ajuste, 1))", opacity: 0.7 };

export function CadenasAdmin({ titre = TITRE_CADENAS }) {
  return (
    <span className="cadenas-admin" style={STYLE} title={titre}>
      <IconeTexte nom="lock-open" titre={titre} />
    </span>
  );
}

export default CadenasAdmin;
